import { Injectable } from '@angular/core';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { map } from 'rxjs/internal/operators/map';
import { OemConstants } from '../oem/constants/oem.constants'
import { DevicesConstants } from '../devices/constants/devices.constants';
import { GlobalConstants } from '../../../../../app/common/constants/global.constant';

@Injectable({
  providedIn: 'root'
})
export class OemService {
  userId = sessionStorage.getItem('userId');
  loginUserRole = sessionStorage.getItem('userRole');
  partnerID = sessionStorage.getItem('partnerID')
  amaData = 'X-Amzn-Trace-Id';
  commonUrl = OemConstants.SKU_COMMON;
  partnerUrl = OemConstants.SLASH_PARTNERS;
  modelSkuUrl = OemConstants.SLASH_MODELSKUS;
  contentUrl = OemConstants.SLASH_CONTENTS;
  attractorURL = OemConstants.SLASH_ATTRACTORLOOP;
  sortBy = OemConstants.SORT_BY;
  createdOn = OemConstants.CREATED_TIME;
  Question = OemConstants.QUESTION;
  getAllModelSKU = `${this.commonUrl}${this.modelSkuUrl}`;
  getAllAttractor = OemConstants.SLASH_ATTRACTORLOOPS;
  autoId: string;
  sortByCreatedTime = `${this.sortBy}${this.createdOn}`;
  getAllContent = `${this.commonUrl}${this.contentUrl}`;
  getAttracts3 = OemConstants.ATTRACT_LOOP_S3;
  MODEL_SKU_URL = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH;
  MODEL_SKU_CREATE_ASSET_THUMBNAIL_S3_URL = OemConstants.SKU_COMMON + OemConstants.SLASH;
  processed_bucket_dev_url = OemConstants.PROCESSED_BUCKET_DEV + OemConstants.SKU_COMMON + OemConstants.SLASH;
  processed_bucket_qa_url = OemConstants.PROCESSED_BUCKET_QA + OemConstants.SKU_COMMON + OemConstants.SLASH;
  processed_bucket_uat_url = OemConstants.PROCESSED_BUCKET_UAT + OemConstants.SKU_COMMON + OemConstants.SLASH;
  processed_bucket_preprod_url = OemConstants.PROCESSED_BUCKET_PREPROD + OemConstants.SKU_COMMON + OemConstants.SLASH;
  processed_bucket_prod_url = OemConstants.PROCESSED_BUCKET_PROD + OemConstants.SKU_COMMON + OemConstants.SLASH;
  attrBaseUrl: string;
  MODEL_SKU_CSV_URL = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH_DOWNLOAD;
  constructor(private httpMethodsService: HttpMethodsService) { }

  getAllModelSKUFunc(sortBy: string, sortType: string) {
    let url = this.getAllModelSKU + OemConstants.SORT_BY + sortBy + OemConstants.SORT_TYPE + sortType;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));

  }

  getALLModelSKUFuncByAutoID() {
    let url = this.getAllModelSKU + OemConstants.SLASH + this.autoId;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getModelSKUDataByAutoID(autoID) {
    let url = this.getAllModelSKU + OemConstants.SLASH + autoID;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllModelSKUBySystemId(sortby: string, sorttype: string, filterString?: string) {
    let url = this.getAllModelSKU + DevicesConstants.SORTBY + sortby + DevicesConstants.SORT_TYPE + sorttype;

    if (filterString) {
      url = `${this.getAllModelSKU}${this.Question}${filterString}`;
    }

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));

  }
  getAllAttractorLoop(sortby: string, sorttype: string, filterString?: string) {
    let url = this.attractorURL + this.getAllAttractor + DevicesConstants.SORTBY + sortby + DevicesConstants.SORT_TYPE + sorttype;

    if (filterString) {
      url = `${this.attractorURL}${this.getAllAttractor}${this.Question}${filterString}`;
    }

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));

  }

  getAttractorLoopByLoopID(attractorLoopID, adminRef, pid) {
    let url = this.attractorURL + this.getAllAttractor + OemConstants.SLASH + attractorLoopID;
    if (adminRef) {
      url = this.attractorURL + OemConstants.SLASH_PARTNERS + OemConstants.SLASH + pid + this.getAllAttractor + OemConstants.SLASH + attractorLoopID;
    }
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllModelSKUBySystemIds(sortby: string, sorttype: string) {
    const url = this.getAllModelSKU + DevicesConstants.SORTBY + sortby + DevicesConstants.SORT_TYPE + sorttype;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));

  }

  SendModelSKUInfoTODE(payload) {
    return this.httpMethodsService.post(this.getAllModelSKU, payload)
      .pipe(map((res: any) =>
        res));
  }

  searchWithSystemID(systemID) {

    let url = this.getAllModelSKU + '?systemidsearch' + '=' + systemID;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  searchWithData(sortby: string, sorttype: string, data, searchTag) {
    let url = this.attractorURL + this.getAllAttractor + DevicesConstants.SORTBY + sortby + DevicesConstants.SORT_TYPE + sorttype + '&' + searchTag + '=' + data;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  uploadAssets(uploadData) {
    const url = this.MODEL_SKU_URL + this.autoId + OemConstants.SLASH_ASSETS;
    return this.httpMethodsService.post(url, uploadData)
      .pipe(map((res: any) =>
        res));
  }

  updateDownloadURL(autoId: string, assetId: string, assetType: string, assetCategory: string) {
    const url = this.MODEL_SKU_URL + autoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH + assetId;
    const loc = window.location.host;
    let assetBaseURL;

    if (loc.indexOf("dev") !== -1 || loc.indexOf("localhost") !== -1) {
      assetBaseURL = this.processed_bucket_dev_url;
    } else if (loc.indexOf("qa") !== -1) {
      assetBaseURL = this.processed_bucket_qa_url;
    } else if (loc.indexOf("uat") !== -1) {
      assetBaseURL = this.processed_bucket_uat_url;
    } else if (loc.indexOf("preprod") !== -1) {
      assetBaseURL = this.processed_bucket_preprod_url;
    } else {
      assetBaseURL = this.processed_bucket_prod_url;
    }

    const payload = {
      downloadURL: assetBaseURL + autoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH + assetCategory + OemConstants.SLASH + assetId + '.' + assetType
    };
    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  uploadImage(image: File, id: string, imageType: string, autoId: string, path: string) {
    const url = this.MODEL_SKU_CREATE_ASSET_THUMBNAIL_S3_URL + autoId + path + id;

    return this.httpMethodsService.putImage(url, image, imageType, true)
      .pipe(map((res: any) =>
        res));
  }

  getAllAssetsByAutoId(type) {
    this.getAutoId();
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH
      + this.autoId + OemConstants.SLASH_ASSETS + OemConstants.QUERY_TYPE + type;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllAssetsByAutoIdContent(type, autoID) {
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH
      + autoID + OemConstants.SLASH_ASSETS + OemConstants.QUERY_TYPE + type;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }
  deleteVideo(assetId) {
    this.getAutoId();
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH
      + this.autoId + OemConstants.SLASH_ASSETS + OemConstants.SLASH + assetId;

    return this.httpMethodsService.delete(url)
      .pipe(map((res: any) =>
        res));
  }
  setAutoId(data) {
    this.autoId = data;
  }

  getAutoId() {
    return this.autoId;
  }

  editModelSKU(payload) {
    let url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH + this.autoId;
    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  getAssetByAutoIdAndAssetId(assetId: string, assetPath) {
    const url = OemConstants.SKU_COMMON
      + OemConstants.SLASH + this.autoId + OemConstants.SLASH_ASSETS + assetPath + OemConstants.SLASH + assetId;

    return this.httpMethodsService.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }
  getAssetByAutoIdAndAssetIdView(assetId: string, assetPath, autoID) {
    const url = OemConstants.SKU_COMMON
      + OemConstants.SLASH + autoID + OemConstants.SLASH_ASSETS + assetPath + OemConstants.SLASH + assetId;

    return this.httpMethodsService.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }

  getAllAssetsByAutoIdForContent(type, autoIdContent: string) {
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH
      + autoIdContent + OemConstants.SLASH_ASSETS + OemConstants.QUERY_TYPE + type;

    return this.httpMethodsService.get(url)
  }
  getAssetByAutoIdAndAssetIdContent(assetId: string, assetPath, autoID?) {
    const url = OemConstants.SKU_COMMON
      + OemConstants.SLASH + autoID + OemConstants.SLASH_ASSETS + assetPath + OemConstants.SLASH + assetId;

    return this.httpMethodsService.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }

  getAssetByAutoIdAndAssetIdForContent(assetId: string, assetPath, autoContentId: string) {
    const url = OemConstants.SKU_COMMON
      + OemConstants.SLASH + autoContentId + OemConstants.SLASH_ASSETS + assetPath + OemConstants.SLASH + assetId;

    return this.httpMethodsService.getImage(url, true)
      .pipe(map((res: any) =>
        res));
  }
  getContentBySystemIdFilter(systemId) {
    let url = this.commonUrl + OemConstants.SLASH + OemConstants.CONTENTS + OemConstants.SYSTEM_ID_FILTER + systemId;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  createNewPartnerContent(content, autoId) {
    let url = this.MODEL_SKU_URL + autoId + OemConstants.SLASH + OemConstants.CONTENTS;

    return this.httpMethodsService.post(url, content)
      .pipe(map((res: any) =>
        res));
  }

  EditPartnerContent(payload, contentId, autoId) {
    let url = this.MODEL_SKU_URL + autoId + OemConstants.SLASH + OemConstants.CONTENTS + OemConstants.SLASH + contentId;

    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  getAllContents(sortby: string, sorttype: string, filterString?: string) {
    let url = this.commonUrl + this.contentUrl + OemConstants.SORT_BY + sortby + OemConstants.SORT_TYPE + sorttype
    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  getAllAssetsByAutoIdForPartnerContent(type, autoIdContent: string) {
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH
      + autoIdContent + OemConstants.SLASH_ASSETS + OemConstants.QUERY_TYPE + type;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }
  getContenBySearch(systemID) {
    let url = this.commonUrl + this.contentUrl + OemConstants.QUESTION + 'contentnamesearch=' + systemID;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res))
  }

  getContentsByFilter(filterString: string) {
    const filterURL = this.commonUrl + this.contentUrl + filterString;

    return this.httpMethodsService.get(filterURL)
      .pipe(map((res: any) =>
        (res))
      );
  }

  getContentDatabyContentID(autoID, contentID) {
    let url = this.commonUrl + this.modelSkuUrl + OemConstants.SLASH + autoID + this.contentUrl + OemConstants.SLASH + contentID;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        (res))
      );
  }

  patchPartnerContentById(inputJson: string, autoId: string, contentId: string) {
    const url = this.getAllModelSKU + OemConstants.SLASH + autoId + OemConstants.SLASH_CONTENTS + OemConstants.SLASH + contentId;
    const addObject = {
      action: 'save',
      configurations: inputJson
    };
    return this.httpMethodsService.patch(url, addObject)
      .pipe(map((res: any) =>
        res));
  }

  getContentDataUsingPartnerID(sortby: string, sorttype: string, pageNumber: number, pID, status) {
    const url = this.commonUrl + this.contentUrl + OemConstants.SLASH + OemConstants.STATUS + OemConstants.SLASH + status + OemConstants.SORT_BY + sortby + OemConstants.SORT_TYPE + sorttype
      + OemConstants.PARTNERID_SEARCH + pID + OemConstants.PAGE_NUMBER + pageNumber;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        (res))
      );
  }

  submitPartnerContent(payload, autoId, contentId) {
    const url = this.MODEL_SKU_URL + autoId + OemConstants.SLASH + OemConstants.CONTENTS + OemConstants.SLASH + contentId;
    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  deletePartnerContent(autoId: string, contentId: string) {
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH
      + autoId + OemConstants.SLASH_CONTENTS + OemConstants.SLASH + contentId;

    return this.httpMethodsService.delete(url)
      .pipe(map((res: any) =>
        res));
  }
  getAllSystemIds() {
    const url = this.getAllModelSKU;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }
  deleteAttractLoop(attractLoopId: string) {
    const url = this.attractorURL + this.getAllAttractor + OemConstants.SLASH
      + attractLoopId;

    return this.httpMethodsService.delete(url)
      .pipe(map((res: any) =>
        res));
  }
  submitAttractLoop(payload, attractLoopId) {
    const url = this.attractorURL + this.getAllAttractor + OemConstants.SLASH + attractLoopId;
    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  createAttractLoop(data) {
    let url = this.attractorURL + this.getAllAttractor
    return this.httpMethodsService.post(url, data)
      .pipe(map((res: any) =>
        res));
  }
  getAssetBaseURL(_forDwnldURL?: boolean) {
    const loc = window.location.host;
    let assetBaseURL = '';
    if (loc.indexOf(OemConstants.DEV) !== -1 || loc.indexOf(OemConstants.LOCALHOST) !== -1) {
      assetBaseURL = (_forDwnldURL) ? OemConstants.PROCESSED_BUCKET_DEV : OemConstants.ORIGINAL_BUCKET_DEV;
    } else if (loc.indexOf(OemConstants.QA) !== -1) {
      assetBaseURL = (_forDwnldURL) ? OemConstants.PROCESSED_BUCKET_QA : OemConstants.ORIGINAL_BUCKET_QA;
    } else if (loc.indexOf(OemConstants.UAT) !== -1) {
      assetBaseURL = (_forDwnldURL) ? OemConstants.PROCESSED_BUCKET_UAT : OemConstants.ORIGINAL_BUCKET_UAT;
    } else if (loc.indexOf(OemConstants.PREPROD) !== -1) {
      assetBaseURL = (_forDwnldURL) ? OemConstants.PROCESSED_BUCKET_PREPROD : OemConstants.ORIGINAL_BUCKET_PREPROD;
    } else {
      assetBaseURL = (_forDwnldURL) ? OemConstants.PROCESSED_BUCKET_PROD : OemConstants.ORIGINAL_BUCKET_PROD;
    }

    // assetBaseURL
    return assetBaseURL;
  }

  putAttractLoop(data, id, index) {
    let url = OemConstants.SLASH_ATTRACTORLOOP + OemConstants.SLASH_ATTRACTORLOOPS + OemConstants.SLASH + id;
    return this.httpMethodsService.putImage(url, data[index], OemConstants.VIDEO, true)
      .pipe(map((res: any) =>
        res));
  }

  patchAttractLoop(data, ids, fileName, name?, configurations?: string, locations?: string, showVideo?: boolean) {
    let assetBaseURL = this.getAssetBaseURL(true);
    let url = OemConstants.SLASH_ATTRACTORLOOP + OemConstants.SLASH_ATTRACTORLOOPS + OemConstants.SLASH + data
    const payload = name ? {
      downloadURL: assetBaseURL + OemConstants.SLASH_ATTRACTORLOOP + OemConstants.SLASH_ATTRACTORLOOPS + OemConstants.SLASH + data,
      action: OemConstants.SAVE,
      systemIDMap: ids,
      attractLoopName: name,
      fileName: fileName,
      configurations: configurations,
      locations: locations,
      showVideo: showVideo
    } : {
      downloadURL: assetBaseURL + OemConstants.SLASH_ATTRACTORLOOP + OemConstants.SLASH_ATTRACTORLOOPS + OemConstants.SLASH + data,
      action: OemConstants.SAVE,
      systemIDMap: ids,
      fileName: fileName
    }
    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  getAttractVideoByAttractLoopId(attractLoopId) {
    let url = this.getAttracts3 + OemConstants.SLASH_ATTRACTORLOOP + OemConstants.SLASH_ATTRACTORLOOPS + OemConstants.SLASH + attractLoopId;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }
  getAllAttracatLoopByPid(pid, sortBy?, type?) {
    let url = `${OemConstants.SLASH_ATTRACTORLOOP}${OemConstants.SLASH_PARTNERS}${OemConstants.SLASH}${pid}${OemConstants.SLASH_ATTRACTORLOOPS}${OemConstants.STAUS_SUBMITTED}${OemConstants.AND_SORT_BY}${sortBy}${OemConstants.SORT_TYPE}${type}`;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) => res));

  }

  getApprovedAttractLoopVideoBypID(sortby: string, sorttype: string, pid) {
    let url = OemConstants.SLASH_ATTRACTORLOOP + OemConstants.SLASH_PARTNERS + OemConstants.SLASH + pid + OemConstants.SLASH_ATTRACTORLOOPS + OemConstants.SORT_BY + sortby + OemConstants.SORT_TYPE + sorttype + OemConstants.AMP + OemConstants.STATUS + OemConstants.EQUAL + OemConstants.APPROVED_STATUS;
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  sendApproveReject(action, pid, attractorLoopID, payload) {
    let url = this.attractorURL + OemConstants.SLASH_PARTNERS + OemConstants.SLASH + pid + this.getAllAttractor + OemConstants.SLASH + attractorLoopID + OemConstants.SLASH + action;
    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  sendApproveAndPush(payload, action: boolean) {
    const url = OemConstants.SKU_COMMON + OemConstants.SLASH_MODELSKUS + OemConstants.SLASH + OemConstants.APPROVED_STATUS + OemConstants.SLASH + OemConstants.PUSH + OemConstants.QUESTION + OemConstants.PUSHTODEVICE + action;

    return this.httpMethodsService.patch(url, payload)
      .pipe(map((res: any) =>
        res));
  }

  postModelSkuCsv(data) {
    const url = `${this.MODEL_SKU_CSV_URL}`
    return this.httpMethodsService.postcsv(url, data)
      .pipe(map((res: any) =>
        res));
  }
  getSort(arrayValue: any[], globalSortValue: string, globalSortValueCompareWith: string, colSortKey: string) {
    const a: any = arrayValue; const b: any = arrayValue;
    if (globalSortValue == globalSortValueCompareWith) {
      return a?.[`${colSortKey}`]?.trim().toLowerCase().localeCompare(b?.[`${colSortKey}`]?.trim().toLowerCase(), undefined, { numeric: true, sensitivity: 'base' });
    } else {
      return b?.[`${colSortKey}`]?.trim().toLowerCase().localeCompare(a?.[`${colSortKey}`]?.trim().toLowerCase(), undefined, { numeric: true, sensitivity: 'base' });
    }
  }

  getSystemIDDataUsingPartnerID(sortby: string, sorttype: string, pageNumber: number, pID, filterString?: string) {
    let url;
    url = this.commonUrl + OemConstants.SLASH + OemConstants.SYSTEMIDS + OemConstants.SORT_BY + sortby + OemConstants.SORT_TYPE + sorttype
      + OemConstants.PAGE_NUMBER + pageNumber + OemConstants.PARTNERID_SEARCH + pID;

    if (filterString) {
      url = `${url}${filterString}`;
    }
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        (res))
      );
  }

  selectAllSystemIDs(filterString?: string, partnerId?: string) {
    let sytemIdurl;
    sytemIdurl = this.commonUrl + OemConstants.SLASH + OemConstants.SYSTEMIDS + OemConstants.PARTNERID_SEARCH_QUESTION + partnerId;

    if (filterString) {
      sytemIdurl = `${sytemIdurl}${filterString}`;
    }

    return this.httpMethodsService.get(sytemIdurl)
      .pipe(map((res: any) =>
        res));
  }

  deleteSystemIDContentByIds(systemIDs) {
    const url = this.getAllModelSKU
      + OemConstants.SLASH + GlobalConstants.DELETE_LOWER;

    return this.httpMethodsService.deleteUser(url, systemIDs)
      .pipe(map((res: any) =>
        res));
  }
}
